import React, { useEffect } from 'react';
import lightbox from '../assets/js/lightbox.min.js';

const Stories = () => {
    useEffect(() => {
        // Initialize the lightbox
        lightbox();
    }, []);
    return (
        <main className="stories">
            <section className="section-01">
                <div className="wrapper">
                    <div className="_left">
                        <div className="content">
                            <h1 className="heading"><span>Through the</span> <br />Seasons <span>of</span> Life</h1>
                            <h2 className="subheading">— Stories from <span>Japan</span></h2>
                            <p className="subtext">“Feeling alive is not tied to any age,<br /> but to how we live each day, in
                                tune with our own pace.”</p>
                            <p className="text">Like the changing skies of Japan, every story in This is Ikigai365 captures a
                                moment in life’s natural rhythm — times of blossoming, of warmth and flow, of slowing down,
                                and of quiet grace.</p>
                            <p className="text">Life circles back with new lessons and new light. <br />Every chapter shows that
                                feeling alive starts with living at a pace that feels natural to us.</p>
                        </div>
                    </div>
                    <div className="_right">
                        <div className="grid">
                            <img src={require("../assets/images/stories/2.jpg")} className="frame" alt="frame" />
                            <img src={require("../assets/images/stories/3.jpg")} className="frame" alt="frame" />
                            <img src={require("../assets/images/stories/4.jpg")} className="frame" alt="frame" />
                            <img src={require("../assets/images/stories/5.jpg")} className="frame" alt="frame" />
                        </div>
                    </div>
                </div>
            </section>
            <section className="section-02">
                <div className="wrapper">
                    <h1 className="heading">Life Worth ≠ Net Worth</h1>
                    <div className="_left">
                        <div className="content">
                            <h2 className="subheading">Meet Fujio-san</h2>
                            <p className="sub-text">“Small happiness leads to big happiness in life.” — Fujio Kojima</p>
                            <p className="text">At seven, Fujio-san came across a series of books on the world’s environmental
                                issues. Somewhere between those pages, he noticed something unusual — the superheroes in the
                                usual books he read battled villains, but the earth’s biggest enemy had no one fighting it.
                                <span>Could he be the one to try?</span>
                            </p>
                            <p className="text">Years later, on a tennis court, he watched champions win and lose…yet neither
                                looked truly happy. It made him wonder: <span>If success doesn’t bring joy, then what
                                    does?</span></p>
                            <p className="text">That question followed him across continents — from the rush of Vietnam to the
                                deep hush of the Amazon — where he began to see a pattern in how human desire shapes the
                                earth.</p>
                            <p className="text">Back in Japan, he created <span>Pirika — ‘beautiful’</span> in the Ainu language
                                — a simple idea that turned litter-picking into a shared act of care.</p>
                            <p className="text"><span>But how did a quiet childhood question grow into a movement spanning 120+
                                countries?</span></p>
                            <p className="text"><span>Experience his full journey in This is Ikigai365.</span></p>
                        </div>
                    </div>
                    <div className="_right">
                        <img src={require("../assets/images/stories/7.jpg")} className="frame" alt="frame" />
                    </div>
                </div>
            </section>
            <section className="section-03">
                <div className="wrapper">
                    <div className="gallery">
                        <div className="one">
                            <a className="link-photo" data-lightbox="img" href={require("../assets/images/stories/10.jpeg")}><img
                                src={require("../assets/images/stories/10.jpeg")} alt="10" /></a>
                            <a className="link-photo" data-lightbox="img" href={require("../assets/images/stories/11.jpeg")}><img
                                src={require("../assets/images/stories/11.jpeg")} alt="11" /></a>
                        </div>
                        <div className="two">
                            <a className="link-photo" data-lightbox="img" href={require("../assets/images/stories/14.png")}><img
                                src={require("../assets/images/stories/14.png")} alt="14" /></a>
                            <a className="link-photo" data-lightbox="img" href={require("../assets/images/stories/9.jpeg")}><img
                                src={require("../assets/images/stories/9.jpeg")} alt="9" /></a>
                            <span>Journey</span>
                        </div>
                        <div className="three">
                            <a className="link-photo" data-lightbox="img" href={require("../assets/images/stories/12.jpeg")}><img
                                src={require("../assets/images/stories/12.jpeg")} alt="14" /></a>
                            <a className="link-photo" data-lightbox="img" href={require("../assets/images/stories/13.png")}><img
                                src={require("../assets/images/stories/13.png")} alt="9" /></a>
                        </div>

                    </div>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => window.open('https://www.penguin.sg/book/this-is-ikigai365', '_blank')}
                    >
                        <span className="material-icons-outlined">flight_takeoff</span>Explore the Book
                    </button>
                </div>
            </section>
            <section className="section-02">
                <div className="wrapper">
                    <h1 className="heading">Creating My Own Ibasho - A Place to Belong’</h1>
                    <div className="_left">
                        <div className="content">
                            <h2 className="subheading">Step into the world of Hanazawa-san</h2>
                            <p className="sub-text">“Kekka Orai — All’s well that ends well.” — Hanazawa-san</p>
                            <p className="text">Hanazawa-san’s story began in her parents’ small restaurant — a warm little
                                world where aromas, laughter, and strangers became friends. Married young and raising three
                                children, she poured herself into home and family… yet a quiet longing grew inside her — for
                                conversations, learning, and a community she hadn’t found yet…. her <span>‘Ibasho’….</span>
                            </p>
                            <p className="text">A simple invitation to a few neighborhood mothers — that’s how it began.</p>
                            <p className="text">Then came the pandemic.<br /> Yuka turned to fermented foods and discovered that
                                calmness creates better food. It opened a path she hadn’t seen before.</p>
                            <p className="text">From that spark came <span>Wabi Sabi,</span> her restaurant, and
                                <span>Ferrum,</span> her rustic food truck serving fermented meals with soul.</p>
                            <p className="text">But how did one small moment grow into a community of women who continue to lift
                                each other up?</p>
                            <p className="text"><span>Experience her full journey in This is Ikigai365.</span></p>
                        </div>
                    </div>
                    <div className="_right">
                        <img src={require("../assets/images/stories/15.jpg")} className="frame" alt="frame" />
                    </div>
                </div>
            </section>
            <section className="section-04">
                <div className="wrapper">
                    <div className="gallery">
                        <div className="one">
                            <a className="link-photo" data-lightbox="img" href={require("../assets/images/stories/18.jpg")}><img
                                src={require("../assets/images/stories/18.jpg")} alt="10" /></a>
                            <a className="link-photo" data-lightbox="img" href={require("../assets/images/stories/17.jpg")}><img
                                src={require("../assets/images/stories/17.jpg")} alt="11" /></a>
                        </div>
                        <div className="two">
                            <a className="link-photo" data-lightbox="img" href={require("../assets/images/stories/19.jpg")}><img
                                src={require("../assets/images/stories/19.jpg")} alt="14" /></a>
                            <a className="link-photo" data-lightbox="img" href={require("../assets/images/stories/21.jpg")}><img
                                src={require("../assets/images/stories/21.jpg")} alt="9" /></a>
                            <span>Journey</span>
                        </div>
                        <div className="three">
                            <a className="link-photo" data-lightbox="img" href={require("../assets/images/stories/16.jpg")}><img
                                src={require("../assets/images/stories/16.jpg")} alt="14" /></a>
                            <a className="link-photo" data-lightbox="img" href={require("../assets/images/stories/20.jpg")}><img
                                src={require("../assets/images/stories/20.jpg")} alt="9" /></a>
                        </div>
                    </div>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => window.open('https://www.penguin.sg/book/this-is-ikigai365', '_blank')}
                    >
                        <span className="material-icons-outlined">flight_takeoff</span>Explore the Book
                    </button>
                </div>
            </section>
            <section className="section-02">
                <div className="wrapper">
                    <h1 className="heading">Rewire – Don’t Retire</h1>
                    <div className="_left">
                        <div className="content">
                            <h2 className="subheading">Meet Ishizaki-san,</h2>
                            <p className="sub-text">“Keizoku wa chikara nari — Persistence always pays off.” — Ishizaki-san</p>
                            <p className="text">Long before social media, Ishizaki-san was already connecting people — <span>one handshake, one bow, one heartfelt ‘thank you’</span> at a time. He believed that every relationship was an investment in trust.</p>
                            <p className="text">After decades in banking, he didn’t slow down. He simply <span>rewired</span> — pouring his energy into building spaces where he brought people together over simple gatherings — art, stories, a shared cup of sake — and found that happiness often opens the door to generosity.</p>
                            <p className="text">Those gatherings slowly led to <span>Japan Platform,</span> a forum supporting victims of natural disasters.</p>
                            <p className="text">But how did a man who <span>‘never retired’</span> turn his network into one of the most heartfelt forces for giving?</p>
                            <p className="text"><span>Experience her full journey in This is Ikigai365.</span></p>
                        </div>
                    </div>
                    <div className="_right">
                        <img src={require("../assets/images/stories/22.jpg")} className="frame" alt="frame" />
                    </div>
                </div>
            </section>
            <section className="section-05">
                <div className="wrapper">
                    <div className="gallery">
                        <div className="one">
                            <a className="link-photo" data-lightbox="img" href={require("../assets/images/stories/23.jpg")}><img
                                src={require("../assets/images/stories/23.jpg")} alt="10" /></a>
                            <a className="link-photo" data-lightbox="img" href={require("../assets/images/stories/24.jpg")}><img
                                src={require("../assets/images/stories/24.jpg")} alt="11" /></a>
                            <a className="link-photo" data-lightbox="img" href={require("../assets/images/stories/25.jpg")}><img
                                src={require("../assets/images/stories/25.jpg")} alt="10" /></a>
                            <a className="link-photo" data-lightbox="img" href={require("../assets/images/stories/26.jpg")}><img
                                src={require("../assets/images/stories/26.jpg")} alt="11" /></a>
                        </div>
                        <div className="two">
                            <a className="link-photo" data-lightbox="img" href={require("../assets/images/stories/28.jpg")}><img
                                src={require("../assets/images/stories/28.jpg")} alt="9" /></a>
                            <a className="link-photo" data-lightbox="img" href={require("../assets/images/stories/27.jpg")}><img
                                src={require("../assets/images/stories/27.jpg")} alt="14" />
                                <span>Journey</span>
                            </a>
                            <a className="link-photo" data-lightbox="img" href={require("../assets/images/stories/29.png")}><img
                                src={require("../assets/images/stories/29.png")} alt="9" /></a>
                        </div>
                    </div>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => window.open('https://www.penguin.sg/book/this-is-ikigai365', '_blank')}
                    >
                        <span className="material-icons-outlined">flight_takeoff</span>Explore the Book
                    </button>
                </div>
            </section>
            <section className="section-02">
                <div className="wrapper">
                    <h1 className="heading">Curiosity is Ageless</h1>
                    <div className="_left">
                        <div className="content">
                            <h2 className="subheading">Step into the world of Ogawa-san</h2>
                            <p className="sub-text">“Learn to play every day, and play rooted in curiosity, because curiosity never dies.” — Ogawa-san</p>
                            <p className="text">Ogawa-san is the first centenarian in our <span>Ikigai365</span> stories — yet the moment you meet her, age quietly disappears. She still studies, learns, and creates with the lightness of someone who never stopped wondering.</p>
                            <p className="text">In her eighties, she learned oil painting.<br /> In her mid-eighties, she explored immunity.<br /> At ninety-nine, she published her first book — researched and typed entirely on her own.</p>
                            <p className="text">Her home reflects her spirit — warm, simple, alive with books, bread, and quiet curiosity. She calls her approach <span>benkyō —</span> learning for one’s own joy.</p>
                            <p className="text"><span>Experience her full journey in This is Ikigai365.</span></p>
                        </div>
                    </div>
                    <div className="_right">
                        <img src={require("../assets/images/stories/30.jpg")} className="frame" alt="frame" />
                    </div>
                </div>
            </section>
            <section className="section-05 mb-12">
                <div className="wrapper">
                    <div className="gallery">
                        <div className="one">
                            <a className="link-photo" data-lightbox="img" href={require("../assets/images/stories/31.jpg")}><img
                                src={require("../assets/images/stories/31.jpg")} alt="10" /></a>
                            <a className="link-photo" data-lightbox="img" href={require("../assets/images/stories/32.jpg")}><img
                                src={require("../assets/images/stories/32.jpg")} alt="11" /></a>
                            <a className="link-photo" data-lightbox="img" href={require("../assets/images/stories/33.jpg")}><img
                                src={require("../assets/images/stories/33.jpg")} alt="10" /></a>
                            <a className="link-photo" data-lightbox="img" href={require("../assets/images/stories/34.jpg")}><img
                                src={require("../assets/images/stories/34.jpg")} alt="11" /></a>
                        </div>
                        <div className="two">
                            <a className="link-photo" data-lightbox="img" href={require("../assets/images/stories/35.jpg")}><img
                                src={require("../assets/images/stories/35.jpg")} alt="9" /></a>
                            <a className="link-photo" data-lightbox="img" href={require("../assets/images/stories/36.jpg")}><img
                                src={require("../assets/images/stories/36.jpg")} alt="14" />
                                <span>Journey</span>
                            </a>
                            <a className="link-photo" data-lightbox="img" href={require("../assets/images/stories/37.jpg")}><img
                                src={require("../assets/images/stories/37.jpg")} alt="9" /></a>
                        </div>
                    </div>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => window.open('https://www.penguin.sg/book/this-is-ikigai365', '_blank')}
                    >
                        <span className="material-icons-outlined">flight_takeoff</span>Explore the Book
                    </button>
                </div>
            </section>

        </main>
    )
}

export default Stories
